module.exports = {
    ifPaymentSuccessful ({ redirectType }, state, output) {
        if (redirectType === 'success') {
            output.yes();
        } else {
            output.no();
        }
    },
    fixOrderId (args) {
        args.orderId = args.orderId.replace('DATUM', '');
    }
};



// WEBPACK FOOTER //
// ./actions/payment/index.js